"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var parts_1 = require("../components/parts");
function default_1(series) {
    var centerBlock;
    if (series) {
        series.forEach(function (individualSeries, seriesIndex) {
            var seriesChildren = React.Children.toArray(individualSeries.props.children);
            seriesChildren.forEach(function (child) {
                if (child.type === parts_1.CenterBlock) {
                    centerBlock = child;
                }
            });
        });
    }
    return centerBlock;
}
exports.default = default_1;
//# sourceMappingURL=getCenterBlock.js.map